export { InlineLabelWrapper } from './InlineLabelWrapper';
